import styled from 'styled-components';
import tinyColor from 'tinycolor2';
export const StyledWrapper = styled.div.withConfig({ displayName: "StyledWrapper", componentId: "-1t2ojj8" }) `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: linear-gradient(
    to bottom right,
    ${(props) => (props.type === 'light' ? props.theme.colors.solitude : props.theme.colors.spaceCadet)},
    ${(props) => props.type === 'light'
    ? tinyColor(props.theme.colors.solitude).darken(10).toString()
    : tinyColor(props.theme.colors.spaceCadet).lighten(10).toString()}
  );
`;
